import * as actionTypes from "./actionTypes";
import * as types from "./types";


// GET Targets

export const fetchTargetListReq = (params: types.ITargetListParams): types.FetchTargetListReq => ({
    type: actionTypes.FETCH_TARGET_LIST_REQUEST,
    params,
});

export const fetchTargetListSuccess = (
    payload: types.FetchTargetListSuccessPayload
): types.FetchTargetListSuccess => ({
    type: actionTypes.FETCH_TARGET_LIST_SUCCESS,
    payload,
});

export const fetchTargetListFailure = (
    payload: types.FetchTargetListFailurePayload
): types.FetchTargetListFailure => ({
    type: actionTypes.FETCH_TARGET_LIST_FAILURE,
    payload,
});


// GET data target

export const fetchTargetDetailsReq = (params: number): types.FetchTargetReq => ({
    type: actionTypes.FETCH_TARGET_REQUEST,
    params,
});

export const fetchTargetDetailsSuccess = (
    payload: types.FetchTargetSuccessPayload
): types.FetchTargetSuccess => ({
    type: actionTypes.FETCH_TARGET_SUCCESS,
    payload,
});

export const fetchTargetDetailsFailure = (
    payload: types.FetchTargetFailurePayload
): types.FetchTargetFailure => ({
    type: actionTypes.FETCH_TARGET_FAILURE,
    payload,
});

export const fetchTargetDetailsReset = (): types.FetchTargetReset => ({
    type: actionTypes.FETCH_TARGET_RESET,
});


// POST Data Target 

export const postDataTargetRequest = (
    payload: types.IPostDataTargetReq
): types.PostDataTargetRequest => ({
    type: actionTypes.POST_DATATARGET_REQUEST,
    payload
});

export const postDataTargetSuccess = (
    payload: types.IPostDataTargetSuccessPayload
): types.PostDataTargetSuccess => ({
    type: actionTypes.POST_DATATARGET_SUCCESS,
    payload,
});

export const postDataTargetFailure = (
    payload: types.IPostDataTargetFailurePayload
): types.PostDataTargetFailure => ({
    type: actionTypes.POST_DATATARGET_FAILURE,
    payload,
});


// PUT data target

export const putDataTargetRequest = (
    targetId: number,
    payload: types.IDataTargetPutReq
): types.PutDataTargetRequest => ({
    type: actionTypes.PUT_DATATARGET_REQUEST,
    targetId,
    payload
});

export const putDataTargetSuccess = (
    payload: types.IPutDataTargetSuccessPayload
): types.PutDataTargetSuccess => ({
    type: actionTypes.PUT_DATATARGET_SUCCESS,
    payload,
});

export const putDataTargetFailure = (
    payload: types.IPutDataTargetFailurePayload
): types.PutDataTargetFailure => ({
    type: actionTypes.PUT_DATATARGET_FAILURE,
    payload,
});


// DELETE data target

export const deleteTargetReq = (
    params: number
): types.DeleteDataTargetRequest => ({
    type: actionTypes.DELETE_TARGET_REQUEST,
    params,
});

export const deleteTargetSuccess = (
    success: types.IDeleteDataTargetSuccess
): types.DeleteDataTargetSuccess => ({
    type: actionTypes.DELETE_TARGET_SUCCESS,
    success,
});

export const deleteTargetFailure = (
    payload: types.IDeleteDataTargetFailurePayload
): types.DeleteDataTargetFailure => ({
    type: actionTypes.DELETE_TARGET_FAILURE,
    payload,
});
// export const fetchSourceDetailsFailure = (
//     payload: types.FetchSourceFailurePayload
// ): types.FetchSourceFailure => ({
//     type: actionTypes.FETCH_SOURCE_FAILURE,
//     payload,
// });



export function fetchStewardRequest(arg0: string): any {
    throw new Error('Function not implemented.');
}

export function fetchAccessControlRequest(): any {
    throw new Error('Function not implemented.');
}

